import Image from 'next/image';

import { Box, Flex, Heading } from '@chakra-ui/react';

import { ButtonLink } from '~/components/button-link';
import { Markdown } from '~/components/markdown';
import { SanityImage } from '~/components/sanity-image';
import { StandardHeroSection } from '~/components/standard-hero';
import { SanityImageType } from '~/features/page-template/models/image';

type MentorHeroSectionProps = {
  heroImage: SanityImageType;
  heroDescription: string;
  pageTitle: string;
  ctaText: string;
};

export function MentorHeroSection({ heroImage, heroDescription, pageTitle, ctaText }: MentorHeroSectionProps) {
  return (
    <StandardHeroSection
      backgroundImageSlot={
        <Box
          bottom='0px'
          pointerEvents='none'
          position='absolute'
          right='calc((100vw - 70rem)/2)'
          top='0px'
          transform='translateX(302px)'
          display={{
            base: 'none',
            md: 'block',
          }}
        >
          <Box height='654px' position='relative' width='941px'>
            <Image
              alt=''
              sizes='941px'
              src='/images/backgrounds/blue-lines-and-shapes.svg'
              style={{
                objectPosition: 'left top',
                objectFit: 'cover',
              }}
              fill
              priority
            />
          </Box>
        </Box>
      }
      contentSlot={
        <Box display='flex' flex={{ md: '1 1' }} flexDirection='column' gap='16px' justifyContent='center'>
          {pageTitle && (
            <Heading as='h1' size='marketing-5xl'>
              {pageTitle}
            </Heading>
          )}

          {heroDescription && <Markdown markdownText={heroDescription} />}

          <Box
            marginTop='20px'
            marginBottom={{
              base: '24px',
              md: 'unset',
            }}
          >
            <ButtonLink
              buttonProps={{
                colorScheme: 'sea-foam',
                // onClick: () =>
                //     trackEvent({
                //         name: 'Open Positions CTA Clicked',
                //         type: 'click',
                //         label: 'open_positions_clicked',
                //         ...analyticsEvent,
                //     }),
                width: {
                  base: '100%',
                  md: 'fit-content',
                },
              }}
              linkProps={{
                href: '#open-positions',
              }}
            >
              {ctaText}
            </ButtonLink>
          </Box>
        </Box>
      }
      imageSlot={
        <Flex
          alignItems='center'
          pointerEvents='none'
          position='relative'
          flex={{
            md: '0 1 648px',
          }}
          justifyContent={{
            base: 'center',
            md: 'flex-end',
          }}
        >
          <Box
            borderRadius='28px 8px 8px 8px'
            overflow='hidden'
            position='relative'
            width='100%'
            height={{
              base: '257px',
              md: '407px',
            }}
            maxWidth={{
              base: '100%',
              md: '544px',
            }}
          >
            <SanityImage
              alt=''
              image={heroImage}
              sizes='544px'
              style={{
                objectFit: 'cover',
              }}
              fill
              priority
            />
          </Box>
        </Flex>
      }
    />
  );
}
